// used for inline ajax request

bq.ajaxAction = function(element, options) {
  this.options   = options;
  this.$el = $(element);
  this.$element  = null;
  this.active    = false;
  this.form = false;
  this.uid = null;
  this.origType = false;
  this.defaultParams = {ajax: true};
  this.isInput = false;
  this.isInputGroup = false;
  this.events = {
    thowUpdate: 'bq.ajaxAction.processStart',
    throwDone: 'bq.ajaxAction.processDone',
    throwNotification: 'bq.notification',
    throwUpdateNotification: 'bq.updateNotification'
  };

};

bq.ajaxAction.DEFAULTS = {
  disableElements: false, //selector list of elements to disable while updating
  notification: true,
  notificationInline: false,
  ajaxUrl: '', //required
  type: 'add', // required - add/remove/update
  eventName: 'click',
  target: false,
  toggle: false,
  highlightSuccess: false,
  params: {},
  formTarget: false,
  relatedForm: false,
  formIsAjaxable: true,
  callbackSuccess: function(){},
  callbackFail: function(){},
  callbackValidationFail: function(){},
  callbackAlways: function(){},
  callBeforeAjax: function(){},
  callAroundAjax: function(){ return false; },
  /** When true, loading state uses bq.viewhandler.progressmessage (full overlay) instead of bq.notification growl. */
  loadingUsesViewHandler: false,
  update: {
    loading: bq.messages.global.updatingItem || "Updating Item...",
    success: "Item Successfully updating",
    error: "There was a problem updating, please try again"
  },
  add: {
    loading: bq.messages.global.addingItem || "Adding Item...",
    success: "Item Successfully added",
    error: "There was a problem adding your Item, please try again"
  },
  remove: {
    loading: bq.messages.global.removingItem || "Removing Item...",
    success: "Item Successfully removed",
    error: "There was a problem removing your Item, please try again"
  }
};

bq.ajaxAction.prototype = {
  init: function() {
    this.$element = (this.options.target) ? $(this.options.target) : this.$el;

    bq.debug.log("Ajax Action : init()", this.$element);

    if(this.options.ajaxUrl.length <= 0) { //if no url or type exit
      bq.debug.error("Ajax Action : required data-* missing", this);
      return;
    }

    this.isInput = this.$element.is('input');
    this.origType = this.options.type;

    if(this.options.formTarget) {
      this.form = $(this.options.formTarget);
    }

    if(this.isInput) {
      if(!this.form) {
        this.form = this.$element.closest('form');
      }
      this.isInputGroup = (this.$element.is('input[type=checkbox]') || this.$element.is('input[type=radio]')) ? true : false;
      this.$element.data('currentVal', this.$element.val());

    }

    this.uid = bq.helper.uniqueId(this.$element);
    this._loadingViewHandlerActive = false;

    this.$element.on(this.options.eventName, {thiz: this}, this._catchEvent);

    if(this.form && this.form.is('form') && this._isFormAjaxable()) {
      //lets catch submit
      this.form.on('submit', {thiz: this}, this._catchFormEvent);
    }

  },

  _isFormAjaxable: function() {
    var submit = this.form.find('.actions button[type="submit"]');

    if (submit.length > 0) {
      var dataBqAttr = submit.attr('data-bq');

	    if (typeof dataBqAttr === typeof undefined || dataBqAttr === false) {
		    this.options.formIsAjaxable = false;
	    }
    }

    if (this.options.eventName == 'focusout' || !this.options.formIsAjaxable) {
       return false;
    }
    return true;
  },

  _ensureBodyViewHandler: function() {
    var $body = $('body');
    if ($body.length && !$body.data('bq.viewHandler') && typeof $.fn.viewHandler === 'function') {
      $body.viewHandler($body.data());
    }
  },

  _stopViewHandlerLoadingIfNeeded: function() {
    if (this._loadingViewHandlerActive) {
      bq.helper.throwEvent('bq.viewhandler.stop', $('body'));
      this._loadingViewHandlerActive = false;
    }
  },

  /** @see bq.getIsThemeNew (bq/core/bq.getIsThemeNew.js) */
  _isNewDesign: function() {
    return bq.getIsThemeNew();
  },

  /** True only when this action opts in (loadingUsesViewHandler) AND new design; legacy uses growl only. */
  _shouldUseViewHandlerLoading: function() {
    return !!(this.options.loadingUsesViewHandler && this._isNewDesign());
  },

  process: function() {
    var el = this.$element;
    var $this = this;
    var params = $.extend({action: this.options.type}, this._getParams());
    var callBeforeAjaxCallback = null;
    if ($this.options.callBeforeAjaxUseInterval) {
      $this.waitBeforeAjaxResponse = true;
      callBeforeAjaxCallback = function() {
        $this.waitBeforeAjaxResponse = false;
      };
    }
    $this.options.callBeforeAjax(params, el, callBeforeAjaxCallback);

    if (this.options.relatedForm) {
      var relatedForm = jQuery(this.options.relatedForm);
      if (relatedForm) {
        var relatedFormParams = bq.helper.formToObject(relatedForm);
        params = $.extend(relatedFormParams, params);
      }
    }

    bq.helper.throwEvent(this.events.thowUpdate, el);

    this._notify('loading');
    this._disable();

    var callAround = $this.options.callAroundAjax($this, params, el);
    if (callAround === false) {
      var postCall = function(params) {
        $.post($this.options.ajaxUrl, params, function (data, textStatus) {
        }, 'json')
            .done(function (json) {
              var type = 'success';

              if (json.error === true || json.error === 'true') {
                type = 'error';
              } else if (json.forward) {
                window.location = json.forward;
                type = 'loading';
              }

              $this._notify(type, json.message);

              if (json.warnings) {
                $this._notify('error', json.warnings);
              }

              if (json.update) {

                if (typeof(json.update) === 'object') {
                  $.each(json.update, function (k, v) {
                    if (v.target) {
                      $(v.target).html(v.html);
                    }
                  });
                } else if (json.update.target && json.update.html) {
                  $(json.update.target).html(json.update.html);
                }
              }

              if (json.clear_ajax_cache === true) {
                bq.selectboxData.cache = {};
              }

              if (json.notifications) {
                $.each(json.notifications, function (k, notification) {
                  bq.helper.throwEvent('bq.notification', $('body'), $.extend(notification, {id: 'notification_' + k}));
                });
              }

              $this.options.callbackSuccess(json, el);
              setTimeout(function(){el.trigger('validated-success');},0);
            })
            .fail(function (jqxhr, textStatus, error) {
              var err = textStatus + ", " + error;
              bq.debug.error("Inline Update : update : ajax error : " + err, this);

              $this._notify('error');
              $this.options.callbackFail(jqxhr, textStatus, error);
              el.trigger('validated-error');
            })
            .always(function (data, textStatus, jqXHR) {
              $this._stopViewHandlerLoadingIfNeeded();
              $this._enable();
              $this._callBackAlways(data, textStatus, jqXHR);
              $this.options.callbackAlways(data, textStatus, jqXHR);
              bq.helper.throwEvent($this.events.throwDone, $this.$element);
            });
      };
      if (callBeforeAjaxCallback) {
        var intervalIndex = 0;
        var requestInterval = setInterval(function(){
          intervalIndex ++;

          if (intervalIndex > 20) {
            clearInterval(requestInterval);
            console.error('Gateway Timeout');
            return;
          }

          if (!$this.waitBeforeAjaxResponse) {
            postCall(params);
            clearInterval(requestInterval);
          }
        } ,500);
      } else {
        postCall(params);
      }
    }
  },

  disable: function(disable) {
    var sel = null;

    if(this.options.disableElements) {
      sel = '#'+this.uid+', '+this.options.disableElements;
    } else {
      sel = '#'+this.uid;
    }

    if(this.options.formTarget && this.form) {
      sel = sel + ', #'+this.form.attr("id")+' button';
    }

    if(disable) {
      $(sel).prop('disabled', true).addClass('disabled');
    } else {
      $(sel).prop('disabled', false).removeClass('disabled');
    }
  },

  _disable: function() {
    this.active = true;
    this.disable(true);
  },

  _enable: function() {
    this.active = false;
    this.disable(false);
  },

  _callBackAlways: function(data, textStatus, jqXHR) {
    var hasError = true;
    if(typeof(jqXHR) === 'string') {
      hasError = true;
    } else {
      hasError = data.error;
    }

    if(hasError === true || hasError === 'true' && this.isInput) { //there was an error
      if(this.isInputGroup) { //if its an input, lets revert checked status
        if(this.$element.prop('checked') === true) {
          this.$element.prop('checked', false);
        } else {
          this.$element.prop('checked', true);
        }
      } else {
        this.$element.val(this.$element.data('currentVal'));
      }

    } else {

      this.options.type = (this.options.toggle && this.origType == this.options.type) ? this.options.toggle : this.origType;

      if(this.isInput) {
        this.$element.data('currentVal', this.$element.val());
      }

      if(this.isInputGroup) {
        if(this.$element.prop('checked') === true) {
          this.$element.parent().addClass('checked');
        } else {
          this.$element.parent().removeClass('checked');
        }
      }

    }

  },

  _notify: function(type, message) {
    if(this.options.notification) {
      var uid = this.uid;

      var msg = (message) ? message : this.options[this.options.type][type] ;

      if(!msg) return;

      var options = {
        text: msg,
        type: type,
        id: 'notification_'+ uid
      };

      switch(type) {
        case 'loading':

          if (this._shouldUseViewHandlerLoading()) {
            var loadMsg = (message) ? message : this.options[this.options.type].loading;
            if (loadMsg) {
              this._ensureBodyViewHandler();
              bq.helper.throwEvent('bq.viewhandler.progressmessage', $('body'), { message: loadMsg });
              this._loadingViewHandlerActive = true;
            }
          } else if(this.options.notificationInline) {
            bq.helper.validation.setLoading(this.$element);
          } else {
            bq.helper.throwEvent(this.events.throwNotification, this.$element, options);
          }
          break;
        case 'success':
          if(this.options.notificationInline) {
            bq.helper.validation.setSuccess(this.$element, false, true);
          } else {
              if(this.options.highlightSuccess) {
                options.type = 'highlight-success';
              }
            bq.helper.throwEvent(this.events.throwUpdateNotification, this.$element, options);
          }
          break;
        case 'error':
          if(this.options.notificationInline) {
            bq.helper.validation.setError(this.$element, msg);
          } else {

            if(Array.isArray(msg) && msg.length > 0) {
              var _this = this;

              $.each(msg, function(k, message) {
	              var options = {
		              text: message,
		              type: type,
		              id: 'notification_' + (k === 0 && $('.bq-notify-loading') .length > 0 ? uid : k)
	              };

	              bq.helper.throwEvent(_this.events.throwUpdateNotification, _this.$element, options);
              });
            } else {
	            bq.helper.throwEvent(this.events.throwUpdateNotification, this.$element, options);
            }
          }
          break;
      }
    }
  },

  _validate: function() {
    if (this.options.validateSelectorField && this.$element && this.$element.data('Parsley')) {
      var result = this.$element.parsley().validate();
      if (Array.isArray(result) && result.length) {
        return false;
      }
      return result;
    }

    if (this.options.validationCallback && typeof this.options.validationCallback === 'function' ) {
      return this.options.validationCallback();
    }

    var relatedForm = jQuery(this.options.relatedForm);
    if (relatedForm && relatedForm.data('Parsley')) {
      if (!relatedForm.parsley().validate()) {
        return false;
      }
    }

    if(this.form && this.form.data('Parsley')) {
      var isValid = this.form.parsley().validate();
      if($('.bundle-revalidate').length) {
        $('.bundle-revalidate').each(function() {
          if (bq.global.parsley.validationEnabled($(this))) {
            $(this).parsley().validate();
          }
        });
      }
      return isValid;
    }

    if(this.form && this.form.hasClass('accounting-container')) {
        return this.form.accountingValidate();
    }

    if(this.form && !this.form.is('form')) {
        var tmpForm = this.form.closest('form');

        if (tmpForm.length <= 0 && this.$element.is('[data-bq="toggle-compare"]') && this.$element.closest('.product_product_with_options_wrapper')) {
	        tmpForm = this.$element.closest('.product_product_with_options_wrapper').find('> form');
        }
        if(this.$element.is('[data-bq="toggle-compare"]')){
          return true;
        }
        if(tmpForm && tmpForm.data('Parsley')) {
          return tmpForm.parsley().validate();
        }
    }

    return true;
  },

  _getParams: function() {

    var extra = {};

    this.options.params = this.$el.data('params'); //reload params incase they have changed

    if(typeof(this.options.params) === "string") {
      try {
        this.options.params = $.parseJSON(this.options.params);
      } catch(ex) {
        bq.debug.error("Add To : error parsing data-params", ex);
        this.options.params = {}; //error parsing json, make blank
      }
    }

    if(this.options.formTarget && this.form) { //should we collect the form
      extra = this.options.formCompress ? bq.helper.formToCompressedData(this.form) : bq.helper.formToObject(this.form);
    } else if(this.isInput) {
      var active = this.$element.checked;
      extra = {
        'name': this.$element.attr('name'),
        'value': this.$element.val(),
        'active': active
      };
    }

    if(!this.options.params && this.$element.data('param-id')) {
      this.options.params = {id: this.$element.data('param-id')};
    }

    return $.extend({}, extra, this.options.params, this.defaultParams);
  },

  _dismiss: function() {
    var el = this.$el; //run the dismiss on the main element, not the target element
    if(el.data('dismiss')) {
      switch(el.data('dismiss')) {
        case 'modal':
          el.closest('.modal').modal('hide');
          break;
        case 'dropdown':
          el.closest('.dropdown-menu').dropdown('toggle');
          break;
        case 'alert':
          el.closest('.alert').alert('close');
          break;
        case 'collapse':
          el.closest('.collapse-group').find('[data-toggle="collapse"]').click();
          break;
      }
    }
  },

  _processEvent: function() {
    var process = true;
    //is it an input, did it change... if not then dont process the event
    if(this.isInput && !this.isInputGroup && this.$element.data('currentVal') === this.$element.val()) {
      process = false;
    }

    if(!this.active && process) {

      if (this._validate()) {
        this.process();
        this._dismiss();
      } else {
        this.options.callbackValidationFail(this.$element);
      }

    }
  },

  _catchEvent: function(e) {
    var $this = e.data.thiz;
    $this._processEvent();
    return false;
  },

  _catchFormEvent: function(e) {
    var $this = e.data.thiz;
    $this._processEvent();
    return false;
  }


};

// Ajax Action PLUGIN DEFINITION
// =======================

var ajaxActionold = $.fn.ajaxAction;

$.fn.ajaxAction = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.ajaxAction');
    var options = $.extend({}, bq.ajaxAction.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.ajaxAction', (data = new bq.ajaxAction(this, options))); }
    data.init();
  });
};

$.fn.ajaxAction.Constructor = bq.ajaxAction;

// Ajax Action NO CONFLICT
// =================

$.fn.ajaxAction.noConflict = function () {
  $.fn.ajaxAction = ajaxActionold;
  return this;
};

// Ajax Action DATA-API
// ==============
bq.ajaxActionInit = function () {
    $('[data-bq="ajax-action"]').each(function () {
      var el = $(this);
      if (el.data('bq.ajaxAction')) { return; }
      el.ajaxAction(el.data());
    });
};

bq.init.push(bq.ajaxActionInit);
